import {useMutation} from "@tanstack/react-query";

import {updateClientMutationOptions} from "./update-client.mutation-options";

export function useUpdateClient(clientId: string) {
  return useMutation(updateClientMutationOptions(clientId));
}
